import React from "react";

const SampleComponent = (props) => {
  return <div>Render aweber component here</div>;
};

export default SampleComponent;
